export const flowCertificateZH = {
  flowCertificate1: '打包下载',
  flowCertificate2: '一键领取',
  flowCertificate3: '下载',
  flowCertificate4: '暂无数据',
  flowCertificate5: '学术荣誉领取邮箱',
  flowCertificate6: '请输入你的学术荣誉领取邮箱',
  flowCertificate7: '任务状态不符， 请返回任务卡重新进入~~~',
  flowCertificate8: '请输入邮箱地址',
  flowCertificate9: '申请已发送，请稍后查看邮箱',
  flowCertificate10: '申请发送失败，请检查邮箱是否正确',
  flowCertificate11: '网络出了点小问题，请稍后再试！',
  flowCertificate12: '提示',
  flowCertificate13: '邮箱格式有误，请重新输入！',
  flowCertificate14: '请输入邮箱！',
  flowCertificate15: '说明：如需修改邮箱，请前往报名资料进行修改，修改完成后再点击提交，系统会给您重新发送证书。',
  flowCertificate16: '证书',
  flowCertificate17: '请用电脑访问www.webloom.cn，查看',
  // flowCertificate18: '系统检测到您所提交文件的部分内容疑似由人工智能(AI)生成，SKT学术委员会将坚决维护学术原创性，请确保您内容的学术原创性。SKT学术组委会将会进行严格复核，若情况属实您的成绩将按学术违规进行处理！您可以在截止日期前修改并重新上传。',
  // flowCertificate18: '作业提交成功！SKT学术组委会将会进行严格复核，若发现您所提交文件由人工智能(AI)生成，将按学术违规进行处理并以邮件通知您！SKT学术委员会将坚决维护学术原创性，请确保您内容的学术原创性。如有需要可重新上传。',
  flowCertificate18: '作业提交成功！组委会坚决维护学术原创性。经GPTZero检测，本次提交作品的人工智能生成内容（AIGC）比例大于学术规则所要求的上限，建议在提交截止时间前，对作品内容进行修改后重新上传。',
  flowCertificate19: '我已知晓!',
  flowCertificate20: '提示',
  flowCertificate21: '此文件部分篇幅疑似AI工具生成',
  flowCertificate22: '提 交',
  flowCertificate23: '已提交',
  flowCertificate24: '修 改',
  flowCertificate25: '请选择'
}

export const flowCertificateEN = {
  flowCertificate1: 'Package Download',
  flowCertificate2: 'One-click claim',
  flowCertificate3: 'Download',
  flowCertificate4: 'No data',
  flowCertificate5: 'E-mail for Academic Honors',
  flowCertificate6: 'Please enter your Academic Honours Recipient Email Address',
  flowCertificate7: 'The task status does not match, please return to the task card to re-enter~~~',
  flowCertificate8: 'Please enter your email address',
  flowCertificate9: 'The application has been sent, please check the email later',
  flowCertificate10: 'If the application fails to be sent, please check if the email address is correct',
  flowCertificate11: 'Network error, please try again later!',
  flowCertificate12: 'Prompt',
  flowCertificate13: 'The email format is incorrect, please re-enter!',
  flowCertificate14: 'Please enter your email!',
  flowCertificate15: 'Note: if you need to modify the mailbox, please go to the registration material to modify, and then click submit after the modification. The system will send you the certificate again. ',
  flowCertificate16: 'Certificate',
  flowCertificate17: 'Please visit www.webloom.cn from your computer to see',
  // flowCertificate18: 'The system has detected that some parts of your document is suspected to be generated by using AI. Please ensure the academic originality of your document! The SKT Academic Committee is determined to maintain academic originality and will carry out rigorous checks, If the situation is confirmed, your results may be canceled! You can revise and re-upload your document before the deadline.',
  // flowCertificate18: 'Submitted! The SKT Academic Committee is determined to maintain academic originality and will carry out rigorous checks, If your document is  generated by using AI, your results may be canceled and you will be notified by email! Please ensure the academic originality of your document! You can revise and re-upload your document.',
  flowCertificate18: 'Submitted! The Organizing Committee resolutely upholds academic originality. According to GPTZero detection, the proportion of AI-generated content (AIGC) in the submitted essay exceeds the maximum threshold permitted',
  flowCertificate19: 'I confirmed!',
  flowCertificate20: 'Attention',
  flowCertificate21: 'Part of this file is suspected to be generated by AI tools',
  flowCertificate22: 'Submit',
  flowCertificate23: 'Submitted',
  flowCertificate24: 'Modify',
  flowCertificate25: 'Please select'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/certificate.js